export default "__VITE_ASSET__b3e18da7__"